import { MortgagePaymentImportActions } from './mortgagePaymentImport.actions';

export const mortgagePaymentImport = {
  namespaced: true,
  actions: {
    ...MortgagePaymentImportActions,
  },
};

export default mortgagePaymentImport;
